/**
 * Opens the theme's native <cart-drawer> from the custom "gs-header" cart icon.
 *
 * The native Dawn header (which owns #cart-icon-bubble and its built-in
 * cart-drawer wiring) is hidden via the `header` section's custom_css in
 * sections/header-group.json, and the visible header is a custom-liquid block
 * whose cart icon is a plain <a href="/cart">. This re-attaches drawer
 * behavior to that visible icon.
 *
 * Uses a delegated listener so it does not depend on cart-drawer.js (deferred,
 * loaded from sections/header.liquid) having upgraded the element yet: the
 * drawer is resolved at click time, and if it is unavailable the click falls
 * through to normal /cart navigation. On the cart page, the current-page link
 * is cancelled so clicking the cart icon is a no-op.
 */
(function () {
  const TRIGGER_SELECTOR = '[data-gs-cart-open], [data-gs-header] a[aria-label="Cart"]';

  function isCurrentCartPage(trigger) {
    if (!trigger?.href) return false;

    const currentUrl = new URL(window.location.href);
    const destinationUrl = new URL(trigger.href, currentUrl);
    const currentPath = currentUrl.pathname.replace(/\/+$/, '');
    const destinationPath = destinationUrl.pathname.replace(/\/+$/, '');

    return currentUrl.origin === destinationUrl.origin && currentPath === destinationPath;
  }

  function getDrawer() {
    const drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.open === 'function' ? drawer : null;
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const trigger = event.target.closest && event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    if (isCurrentCartPage(trigger)) {
      event.preventDefault();
      return;
    }

    const drawer = getDrawer();
    if (!drawer) return;

    event.preventDefault();
    drawer.open(trigger);
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!getDrawer()) return;
    const triggers = document.querySelectorAll(TRIGGER_SELECTOR);
    for (let i = 0; i < triggers.length; i++) {
      triggers[i].setAttribute('aria-haspopup', 'dialog');
    }
  });
})();
